import React from 'react';
import "./filter.scss";
import Dropdown from '../../../common/dropdown-v2/dropdown';
import DropdownV4 from '../../../common/dropdown-v4/dropdown';
import { Constants, ImageConstants } from '../../../../constants/constants';
import { getImageSource } from '../../../../utility/image-source'
import SchoolApi from '../../../../apis/school'
import MasterDataApi from '../../../../apis/master-data'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import CommonApi from '../../../../apis/common'
import 'bootstrap-daterangepicker/daterangepicker.css';
import PillButtonSelect from '../../../common/pill-button-select/pill-button-select';
import SessionCache from '../../../routes/session-cache';

class FilterComponent extends React.Component {

    state = {
        showShadow: false,
        showFilters: true,
        disableGo: true,
        questionSource: 'countingwell',
        boardsDropdownItems: [],
        classDropdownItems: [],
        chapterDropDownItems: [],
        teachersDropDownItems: [],
        selectedBoard: {},
        selectedClass: "",
        selectedChapterKey: [],
        selectedTeachersId: [],
        eloDropdownItems: [],
        disableClass: true,
        disableChapters: true,
        durationDropDown: [],
        singleChapterDropdown: [{ title: "15 Mins", value: 15 }],
        selectedChapter: [],
        duration: 15,
        maxChapterSelection: 4,
        sectionDropdownItems: [],
        assessmentType: 'DIAGNOSTIC',
        subSubjectsDropDownItems: [
            {
                title: 'Physics',
                value: '6825751af19678f87dd72e9c'
            },
            {
                title: 'Chemistry',
                value: '68ad5e67a5611fe85d55d17c'
            },
            {
                title: 'Biology',
                value: '68ad5e67a5611fe85d55d17d'
            }
        ]
    }

    classSectionHash = {}
    config = {}

    constructor(props) {
        super(props)
        this.user = SessionCache.getUser()
    }

    componentDidMount() {
        this.getClasses()
        this.getMisc()
    };


    getMisc() {
        let payload = {
            "type": "ASSESSMENT_META"
        }
        CommonApi.getMisc(payload)
            .then(response => {
                let misc = response[0]
                this.config = misc
                console.log(this.config)
                this.setState({ maxChaptersAllowed: misc.maxChaptersAllowed })
            }).catch(err => {
            })
    }


    getClasses(payload = {}) {
        SchoolApi.getClassAndBoard(payload)
            .then(school => {
                let classes = [], boards = [];
                for (let i = 0; i < school.classes.length; i++) {
                    classes.push({
                        title: school.classes[i].name,
                        value: school.classes[i].name,
                    })
                }

                for (let i = 0; i < school.boards.length; i++) {
                    boards.push({
                        title: school.boards[i].name,
                        value: school.boards[i].name,
                    })
                }

                if (boards.length > 1) {
                    this.setState({ boardsDropdownItems: boards })
                } else {
                    this.setState({ selectedBoard: boards[0] })
                }
                this.setState({ classDropdownItems: classes, selectedClass: null, reloadClassPill: true }, () => {
                    this.setState({ reloadClassPill: false })
                })
            }).catch(err => {
            })
    }

    getSections(payload = {}) {

        if (!payload.class) payload.class = this.state.selectedClass?.value
        if (!payload.board) payload.board = this.state.selectedBoard?.value

        if (this.classSectionHash[payload.board + payload.class]) {
            this.setState({ sectionDropdownItems: this.classSectionHash[payload.board + payload.class], selectedSection: "" })
            // this.reloadDropdown()
            return
        }

        SchoolApi.getSections(payload)
            .then(response => {
                let sections = []
                for (let i = 0; i < response.response.length; i++) {
                    if (!response.response[i].noSectionInClass) {
                        sections.push({
                            title: response.response[i].section,
                            value: response.response[i].section,
                            sectionId: response.response[i]._id
                        })
                    }
                }

                console.log(sections)


                this.classSectionHash[payload.board + payload.class] = sections?.length ? sections : null
                this.setState({ sectionDropdownItems: sections, selectedSection: "" })
                // this.reloadDropdown()
            }).catch(err => {
            })
    }

    getChapters(payload = {}) {

        if (!payload.class) payload.class = this.state.selectedClass?.value
        // if (!payload.board) payload.board = this.state.selectedBoard

        if (this.user.subjectId === Constants.SCIENCE_SUBJECTID) {
            payload.subSubjectId = this.state.selectedSubSubjectId?.value
        }

        payload.type = this.props.type


        if (!payload.class) return
        MasterDataApi.getAssessmentChapterList(payload)
            .then(response => {
                console.log(response)
                let chapters = response.chapterList
                // response = response.data
                // this.setState({ masterDataId: response._id })
                // for (let i = 0; i < response.chapters.length; i++) {
                //     let chapter = response.chapters[i], concepts = []
                //     chapters.push({
                //         title: chapter.title,
                //         value: chapter.key,
                //     })
                // }
                this.setState({ chapterDropDownItems: chapters, selectedChapter: "", reloadChapterDropdown: true }, () => {
                    this.setState({ reloadChapterDropdown: false })
                })
            }).catch(err => {
            })
    }

    reloadDropdown() {
        this.setState({ reloadDropdown: true }, () => {
            this.setState({ reloadDropdown: false })
        })
    }

    resetDropDowns(callback) {
        this.setState({
            selectedBoardId: "",
            selectedClassId: "",
            chapterDropdownItems: [],
        }, () => { if (callback) callback(); });
    }


    refreshPage() {
        this.setState(
            { reload: true },
            () => this.setState({ reload: false })
        )
    }

    toggleFilters = () => {
        this.setState({ showFilters: !this.state.showFilters })
    }

    onSelectPillButton = (option, key) => {
        console.log(option)
        let reloadChapterDropdown = false, selectedChapter = this.state.selectedChapter
        if (key === "selectedSection") {
            reloadChapterDropdown = true
            selectedChapter = null
        }


        this.setState({ [key]: option, reloadChapterDropdown, selectedChapter }, () => {
            if (key == "selectedBoard") {
                this.getClasses()
                this.setState({ sectionDropdownItems: [] })
                if (this.props.onBoardChange) this.props.onBoardChange()
                this.setState({
                    selectedClass: "",
                    selectedSection: "",
                    questionSource: "countingwell",
                    duration: 15,
                    selectedChapter: []
                })
            }
            if (key === "selectedClass") {
                // this.getSections({ class: option?.value })
                this.getChapters()
                this.setState({ durationDropDown: [], duration: "" })
            }

            // if (key === "selectedSection") {
            //     this.setState({ reloadChapterDropdown: false }, () => {
            //         this.onMultiSelectDropdown([], "selectedChapter")
            //     })
            //     this.emitChanges(null, key === "selectedClass" || key === "selectedBoard" || key === "selectedSection")
            // } else {
            //     this.emitChanges(null, key === "selectedClass" || key === "selectedBoard" || key === "selectedSection")
            // }
        })
    }
    onMultiSelectDropdown = (options, key) => {
        let value = []
        options = options.sort((a, b) => a.order - b.order)
        for (let i = 0; i < options.length; i++) {
            let option = options[i]
            value.push(option)

            if (key == "selectedChapter") {
                let chapterInfo = this.config.chapters
                let configs = chapterInfo[value.length]
                if (configs) {
                    let dropdownList = []
                    configs.forEach(element => {
                        let obj = {
                            title: `${element.duration?.value} ${element.duration?.unit}`,
                            value: element.duration?.value
                        }
                        dropdownList.push(obj)
                    });
                    this.setState({ durationDropDown: dropdownList, reloadDurationDropdown: true }, () => {
                        this.setState({ reloadDurationDropdown: false })
                    })
                } else {
                    this.setState({ durationDropDown: [], duration: "", reloadDurationDropdown: true }, () => {
                        this.setState({ reloadDurationDropdown: false })
                    })
                }
            }
        }
        this.setState({ reloadDropdown: false, [key]: value, duration: "" }, () => {
            this.setState({ reloadDropdown: false })
            this.emitChanges(key == "selectedChapter")
        })
    }

    handleDateEvent = (event, picker) => {
        this.startDate = new Date(picker.startDate);
        this.setState({ selectedDate: this.startDate.toLocaleDateString() });
        this.emitChanges()
    }


    emitChanges(reloadQuestion, reloadStudent) {

        // let chapters = []

        // if (this.state.selectedChapter && this.state.selectedChapter?.length) {
        //     chapters = this.state.selectedChapter?.map(item => {
        //         return {
        //             key: item.value,
        //             title: item.title
        //         }
        //     })
        // }

        let payload = {
            schoolId: this.user.schoolInfo.schoolCode,
            board: this.state.selectedBoard?.value,
            class: this.state.selectedClass?.value,
            section: this.state.selectedSection?.title,
            sectionId: this.state.selectedSection?.sectionId,
            chapters: this.state.selectedChapter,
            dueDate: this.startDate ? (new Date(new Date(this.startDate).setHours(23, 59, 59, 999)).toISOString()) : "",
            masterDataId: this.state.masterDataId,
            duration: this.state.selectedChapter.length === 1 ? 15 : this.state.duration,
            questionSource: this.state.questionSource,
            assessmentType: this.state.assessmentType
        }

        if (this.user.subjectId === Constants.SCIENCE_SUBJECTID) {
            payload.subSubjectId = this.state.selectedSubSubjectId?.value
            payload.subSubjectName = this.state.selectedSubSubjectId?.title
        }

        console.log(payload)

        if (this.props.onGo) {
            this.props.onGo(payload, reloadQuestion, reloadStudent)
        }
    }

    onSelectDropDown = (option, key) => {
        this.setState({ [key]: option?.value }, () => {
            this.emitChanges(key == "duration")
        })
    }

    onSelectChapter = (option) => {
        if (option) option = [option]
        this.setState({ "selectedChapter": option }, () => {
            this.emitChanges(true)
            // if (this.props.resetSelectedQuestions) this.props.resetSelectedQuestions()
        })
    }

    getChapterSelectedOrNot(value) {
        let chapters = this.state.selectedChapter || []
        for (let i = 0; i < chapters.length; i++) {
            if (chapters[i].value === value) return true
        }

        return false
    }

    setQuestionSource = val => {
        this.setState({ questionSource: val }, _ => {
            this.emitChanges(true)
        })
    }

    setAssessmentType(type) {
        this.setState({ assessmentType: type }, () => {
            this.emitChanges(true)
        })
    }

    render() {
        const { questionSource } = this.state
        return (

            <div className="new-test-filter">
                {
                    !this.state.reload ?
                        <div className={this.state.showFilters ? "filter-content" : "filter-content d-none"} >
                            <div className="row">

                                {
                                    this.user.subjectId === Constants.SCIENCE_SUBJECTID ?
                                        <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                            <div className="filter-input-label">
                                                Subjects<span className='text-danger'>*</span>
                                            </div>
                                            <div className={this.props.isCreate && !this.state.subSubjectId ? 'error-border' : ''}>
                                                <Dropdown
                                                    placeholder='Select a board'
                                                    options={this.state.subSubjectsDropDownItems}
                                                    onSelect={(option) => this.onSelectPillButton(option, "selectedSubSubjectId")}
                                                    text={"title"}
                                                    value={this.state.subSubjectId}

                                                />
                                            </div>
                                            {this.props.isCreate && !this.state.subSubjectId ? <div className='error-text text-danger'>Please Select a board</div> : ''}
                                        </div>
                                        :
                                        <></>

                                }


                                {
                                    this.state.boardsDropdownItems.length > 1 ?
                                        <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                            <div className="filter-input-label">
                                                Board<span className='text-danger'>*</span>
                                            </div>
                                            <div className={this.props.isCreate && !this.state.selectedBoard ? 'error-border' : ''}>
                                                <Dropdown
                                                    placeholder='Select a board'
                                                    options={this.state.boardsDropdownItems}
                                                    onSelect={(option) => this.onSelectPillButton(option, "selectedBoard")}
                                                    text={"title"}
                                                    value={this.state.selectedBoard}

                                                />
                                            </div>
                                            {this.props.isCreate && !this.state.selectedBoard ? <div className='error-text text-danger'>Please Select a board</div> : ''}
                                        </div>
                                        : ""
                                }

                                {
                                    !this.state.reloadClassPill ?
                                        <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                            <div className="filter-input-label">
                                                Class<span className='text-danger'>*</span>
                                            </div>
                                            <div className={this.props.isCreate && !this.state.selectedClass ? 'error-border' : ''}>
                                                {!this.state.reloadDropdown ?
                                                    <Dropdown
                                                        placeholder='Select a Class'
                                                        options={this.state.classDropdownItems}
                                                        onSelect={(option) => this.onSelectPillButton(option, "selectedClass")}
                                                        text={"title"}
                                                        value={this.state.selectedClass}

                                                    /> : ''}
                                            </div>
                                            {this.props.isCreate && !this.state.selectedClass ? <div className='error-text text-danger'>Please Select a class</div> : ''}
                                        </div>
                                        : ""
                                }
                                {

                                    // <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    //     <div className="filter-input-label">
                                    //         Section<span className='text-danger'>*</span>
                                    //     </div>
                                    //     <div className={this.props.isCreate && !this.state.selectedSection ? 'error-border' : ''}>
                                    //         {
                                    //             !this.state.reloadDropdown ?
                                    //                 <Dropdown
                                    //                     key="class"
                                    //                     placeholder='Select a Section'
                                    //                     options={this.state.sectionDropdownItems}
                                    //                     onSelect={(option) => this.onSelectPillButton(option, "selectedSection")}
                                    //                     text={"title"}
                                    //                     value={this.state.selectedSection}

                                    //                 >
                                    //                 </Dropdown>
                                    //                 : ""
                                    //         }
                                    //     </div>
                                    //     {this.props.isCreate && !this.state.selectedSection ? <div className='error-text text-danger'>Please Select a Section</div> : ''}
                                    // </div>

                                }

                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    <div className="filter-input-label">
                                        Chapter<span className='text-danger'>*</span>
                                    </div>
                                    <div className={this.props.isCreate && !this.state.selectedChapterKey ? 'error-border' : ''}>
                                        {!this.state.reloadChapterDropdown ?
                                            <Dropdown
                                                placeholder='Select Chapter'
                                                options={this.state.chapterDropDownItems}
                                                onSelect={(option) => this.onSelectChapter(option)}
                                                text={"title"}
                                                value={this.state.selectedChapter}
                                                disabled={this.props.delegate?.props?.delegate?.props?.delegate?.props?.location?.state?.homeworkAssignPayload?.forWhat === 'PREVIOUS_KNOWLEDGE'}
                                            >
                                            </Dropdown> : ''
                                        }
                                    </div>
                                    {this.props.isCreate && !this.state.selectedChapterKey ? <div className='error-text text-danger'>Please Select a Chapter</div> : ''}
                                </div>
                            </div>


                            {/* {
                                this.state.selectedSection &&
                                <div className='ml-2 d-flex button-wrapper mt-3 mb-5'>
                                    <div className='d-flex align-items-center cursor-pointer' onClick={() => this.setAssessmentType('CHAPTER')}>
                                        <div className='radio-button-wrapper mr-2 d-flex justify-content-center align-items-center' >
                                            {this.state.assessmentType === 'CHAPTER' ? <div className='inner-selection'></div> : <></>} </div>
                                        <div className='title-text'>Chapter</div>
                                    </div>
                                    <div className='d-flex ml-3 align-items-center cursor-pointer' onClick={() => this.setAssessmentType('DIAGNOSTIC')}>
                                        <div className='radio-button-wrapper mr-2 d-flex justify-content-center align-items-center' >
                                            {this.state.assessmentType === 'DIAGNOSTIC' ? <div className='inner-selection'></div> : <></>} </div>
                                        <div className='title-text'>Diagnostic</div>
                                    </div>
                                </div>
                            } */}

                            {/* {
                                this.state.assessmentType === 'CHAPTER' ?
                                    <>
                                        {this.state.selectedClass ?
                                            <div className="pt-4">
                                                <div className="filter-input-label">
                                                    Chapter
                                                </div>
                                                <div>
                                                    {
                                                        !this.state.reloadChapterDropdown ?
                                                            this.state.selectedSection && this.props.type != "DIAGNOSTIC" ?
                                                                <DropdownV4
                                                                    key="chapter-multi-select"
                                                                    placeholder='Select Chapter'
                                                                    options={this.state.chapterDropDownItems}
                                                                    onSelect={(option) => this.onMultiSelectDropdown(option, "selectedChapter")}
                                                                    text={"title"}
                                                                    multiSelect
                                                                    max={this.state.maxChaptersAllowed || 4}
                                                                    value={this.state.selectedChapter}
                                                                />
                                                                : <DropdownV4
                                                                    key="chapter-single-select"
                                                                    placeholder='Select Chapter'
                                                                    options={this.state.chapterDropDownItems}
                                                                    onSelect={(option) => this.onSelectChapter(option)}
                                                                    text={"title"}
                                                                    showRadio
                                                                />
                                                            : ""
                                                    }
                                                </div>
                                                {this.state.selectedSection && this.props.type != "DIAGNOSTIC" ? <div className="note pt-2 pl-2">NOTE: Max 4 chapters could be selected for assessment at section level</div> : ""}
                                            </div>
                                            : ""
                                        }


                                    </>
                                    :
                                    <>
                                    </>
                            } */}


                        </div>
                        :
                        ""

                }
            </div>


        );
    }

}

export default FilterComponent;